export enum LicenseType {
    DEMO = 0,
    ONETIME = 1,
    FOR_YEAR = 2,
    FOR_USER = 3,
    // ADMSPEC = 4,
    FOR_YEAR_PLUS = 5,
    RESPONDENT_PANEL = 6,
}

export const LicenseNames = {
    [LicenseType.DEMO]: 'Демо-лицензия',
    [LicenseType.ONETIME]: 'Разовая лицензия',
    [LicenseType.FOR_YEAR]: 'Годовая лицензия',
    [LicenseType.FOR_USER]: 'Доп. пользователи',
    [LicenseType.FOR_YEAR_PLUS]: 'Годовая лицензия',
    [LicenseType.RESPONDENT_PANEL]: '',
};

export const panelLicenseData = {
    id: LicenseType.RESPONDENT_PANEL,
    name: '',
    price: 1,
};

export const PANEL_LICENSE_TAX = 7;
